const Hammer = require('hammerjs')

module.exports = function () {

  const $menu = $('#header-menu'),
    $menu_button = $('#menu-button'),
    $body_html = $('body, html'),
    $dropdowns = $('.header-menu-dropdown ul')

  const menu_el = $menu.get(0)
  if (menu_el) {
    const mc = new Hammer(menu_el)
    mc.on('swiperight', function(ev) {
      close()
    })
  }

  function open () {
    $menu.addClass('open')
    $body_html.addClass('no-scroll')
  }

  function close () {
    if($menu.hasClass('open')){
      $menu.removeClass('open')
      $body_html.removeClass('no-scroll')
    }
  }


  // Events

  $menu_button.on('click', open)

  $menu.find('.cross').on('click', close)

  $menu.on('click', function(event){
    const $target = $(event.target)

    if($target.hasClass('header-menu-bg') || $target.hasClass('header-menu')){
      close()
    }
  })

  $dropdowns.siblings('h3').on('click', function () {
    $dropdowns.slideUp()
    if (!$(this).hasClass('active')) {
      $dropdowns.siblings('h3').removeClass('active')
      $(this).addClass('active').siblings('ul').slideDown()
    }
    else {
      $(this).removeClass('active')
    }
  })

  return {
    open: open,
    close: close
  }
}
